import { useEffect, useRef, useState } from 'react';
import 'tippy.js/dist/tippy.css';
import './style.css';
import { Link } from 'react-router-dom';
import Load from '../load/cast';
import { departments, jobs } from '../../../../../../../../../components/jobs-departments';

export default function Crew( { id, season, episode } ) {

    const [ cast, setCast ] = useState([]);
    const image_path = 'https://image.tmdb.org/t/p/w138_and_h175_face';

    const [ castLengthVisible, setCastLengthVisible ] = useState(15);
    const [ loadingCast, setLoadingCast ] = useState(true);
 
    const [ language, setLanguage ] = useState();
    const swiperRef = useRef(null);

    useEffect(()=> {
        setCastLengthVisible(15);
        
        if (swiperRef && swiperRef.current) {
            swiperRef.current.swiper.slideTo(0);
        }
    }, [ id ]);
    
    useEffect(() => {

        setLoadingCast(true);

        var language = localStorage.getItem('idioma') || 'portugues';
        setLanguage(language);
        fetch(`https://api.themoviedb.org/3/tv/${id}/season/${season}${episode ? `/${episode}` : ''}/credits?api_key=${process.env.REACT_APP_TMDB_KEY}&language=${language == 'ingles' ? 'en-US' : 'pt-BR'}`)
        .then(Response => Response.json())
        .then(data => {
            
            setCast(data)
            setLoadingCast(false);

        });

    }, [id, season]);

    const loadMore = () => {
        const remainingElenco = cast.length - castLengthVisible;
        const nextBatch = Math.min(remainingElenco, 10);
        setCastLengthVisible(prevCastLengthVisible => prevCastLengthVisible + nextBatch);
    };

    return (
        <div className='container-crew'>
            {loadingCast &&
                <div id='div-elenco'>
                    <h2 className="h2-elenco-details-movie h2-titulo-sections" id="h2-sugestoes">{language == 'ingles' ? 'Production' : 'Equipe de Produção'}</h2>
                    <Load />
                </div>
            }
            {(cast?.crew && cast?.crew.length >= 1) &&
                <div id='div-elenco'>
                    <h2 className="h2-elenco-details-movie h2-titulo-sections" id="h2-sugestoes">{language == 'ingles' ? 'Production' : 'Equipe de Produção'}</h2>
                    <div className='content-crew'>
                        {cast?.crew.slice(0, 100).map((crew, key) =>{
                            return(
                                <Link to={`/pessoa/${crew.id}/bg=movie/filmes`} className='people-crew' key={key}>
                                    <img loading="lazy" src={crew.profile_path ? (`${image_path}${crew.profile_path}`) : 'https://dflix.netlify.app/imagens/img-avatar.png'} alt={crew.name} onError={({ currentTarget }) => {currentTarget.onerror = null; currentTarget.src='https://dflix.netlify.app/imagens/img-avatar.png';}}/>
                                    <section className='section-info-crew'>
                                        {crew.original_name && 
                                            <span className='nome-ator'>{crew.original_name}</span>
                                        }
                                        <span className='nome-personagem'>{departments[crew?.department]}</span>
                                        <span className='nome-personagem'>{jobs[crew?.job]}</span>
                                    </section>
                                </Link>
                            )
                        })}
                    </div>
                </div>
            }
        </div>
    )
}